import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { ClickAwayListener, Popper } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

const useStyles = makeStyles({
  root: {
    // renderView portals the calendar; hide its original, now empty container.
    "& > .rdt > .rdtPicker": { display: "none" }
  }
});
const popperOptions = { positionFixed: true };
const modifiers = {
  flip: { enabled: true, boundariesElement: "viewport", padding: 8 },
  preventOverflow: { boundariesElement: "viewport", padding: 8 }
};

export default function TSDialogDatetime({ portalTarget, disabled = false, inputProps = {}, closeOnSelect = true, onChange, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <ClickAwayListener onClickAway={close}>
      <div ref={anchorRef} className={classes.root}>
        <Datetime {...props} open={open && !disabled} closeOnClickOutside={false} closeOnSelect={closeOnSelect}
          onChange={value => { if (closeOnSelect) close(); if (onChange) onChange(value); }}
          onOpen={() => setOpen(true)} onClose={close}
          inputProps={{ ...inputProps, disabled,
            onClick: () => { if (!disabled) setOpen(true); },
            onKeyDown: event => {
              if (open && event.key === "Escape") { event.stopPropagation(); close(); }
            }
          }}
          renderView={(view, renderDefault) => (
            <Popper open={open && !disabled && !!portalTarget} anchorEl={anchorRef.current}
              container={portalTarget} placement="bottom-start" popperOptions={popperOptions} modifiers={modifiers}
              role="presentation" style={{ zIndex: theme.zIndex.modal + 1, width: 280, maxWidth: "calc(100vw - 16px)" }}>
              <div className="rdtPicker" style={{ display: "block", position: "static", width: "100%", minWidth: 0,
                margin: 0, boxSizing: "border-box", maxHeight: "calc(100vh - 16px)", overflowY: "auto" }}>
                {renderDefault()}
              </div>
            </Popper>
          )} />
      </div>
    </ClickAwayListener>
  );
}

TSDialogDatetime.propTypes = {
  portalTarget: PropTypes.object,
  disabled: PropTypes.bool,
  inputProps: PropTypes.object,
  closeOnSelect: PropTypes.bool,
  onChange: PropTypes.func
};
